module.exports = __webpack_public_path__ + "static/flags/VM-70ed1cd19728e733d9aafd62dda367bf.gif";